import { useMemo } from 'react'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useMailchimpFetchAudienceLists } from 'hooks/queries/externalIntegrations/useMailchimpFetchAuidence'
import { MailchimpUser } from '../types'

export const useMailchimpIntegration = (workspaceId: number) => {
  const { data: integrationsData, isLoading: integrationsLoading } = useExternalIntegrations()

  const mailchimpIntegration = useMemo(() => {
    const integrations = Array.isArray(integrationsData?.external_integrations)
      ? integrationsData.external_integrations
      : []
    return integrations.find((integration: any) => integration.provider === 'mailchimp')
  }, [integrationsData])

  const mailchimpProfile = useMemo(() => {
    return mailchimpIntegration?.additional_data as MailchimpUser
  }, [mailchimpIntegration])

  const {
    data: audienceLists,
    isLoading: audienceLoading,
    error: audienceError,
  } = useMailchimpFetchAudienceLists(workspaceId, !!mailchimpIntegration)

  return {
    mailchimpIntegration,
    mailchimpProfile,
    audienceLists: audienceLists ?? [],
    audienceLoading,
    audienceError,
    integrationsLoading,
    hasIntegration: !!mailchimpIntegration,
    hasProfile: !!mailchimpProfile,
  }
}
